var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.8 8.796-6.1 5.5v3.2l6.1 5.5c.5.4 1.2.2 1.6-.3.1-.2.2-.4.2-.6v-12.3c0-.6-.5-1.2-1.1-1.2-.2 0-.5.1-.7.2zM18.3 8.996h-14c-.5 0-.9.4-1 .9v12c0 .5.4 1 .9 1h14.1c.5 0 .9-.4 1-.9v-12c0-.5-.4-1-.9-1h-.1z"
  })));
};
export default SvgVideo;